import { createRouter, createWebHistory, type RouterScrollBehavior } from 'vue-router'
import routes from './routes'

import { globalStore } from '@stores/globalStore'

const scrollBehavior: RouterScrollBehavior = (to, from, savedPosition) =>
  (to.path === from.path) && savedPosition ? savedPosition : { left: 0, top: 0 }

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior
})

router.beforeEach(async(to) => {
  const globStore = globalStore()

  if (!globStore.isCheckedAuthorization) {
    await globStore.getUserInfo(true)
  }

  if (import.meta.env.MODE !== 'development') {
    if (!globStore.isAuthorized && ['login', 'check-email', 'set-password'].every((routeName) => routeName !== to.name)) {
      return { name: 'login' }
    }

    if (globStore.isAuthorized && ['login', 'check-email', 'set-password'].some((routeName) => routeName === to.name)) {
      return { name: 'points' }
    }
  }

  if (to.name === 'home') {
    return { name: 'points' }
  }
})

export default router
